import {
  registerMicroApps,
  start,
  prefetchApps,
  initGlobalState,
  MicroAppStateActions,
} from 'qiankun'
import Vue from 'vue'
import App from './App'
import router from './routes'

import '@babel/polyfill'
// import Llsweb from 'llsweb'

import $ from 'jquery'
import './styles/reset.css'
import './styles/common.css'
//代码自动化生成页面需要用到的样式
import './styles/auto/sear.css'
import './styles/auto/form.css'
import './styles/auto/wkfl.css'
//自定义公共过滤器，指令，方法和插件
import './common/filter.js'
import './common/directive.js'
import './common/prototype.js'
import './common/plug.js'
//引用全局变量文件
import globalVariable from '@/common/global_variable.js'
//接口请求配置文件
// import './https/https.js'
import httpsAxios from './https/https_lls'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//引入vuex
import store from './store/index'
//引入国际化语音
import i18n from './i18n/index'
//引入接口管理
import API from '@/api/index.js'
// svg组件
import '@/views/components/svgIcon'

import I18nPdfViewer from "@linklogis/i18n-pdf-viewer"; // 预览合同

// dyy 不知道为什么云桌面按需引入不成功 于是选择了全部引入 0823
import LinkUI from 'link-ui-i18n';
import 'link-ui-i18n/lib/theme-chalk/index.css';

import infiniteScroll from 'vue-infinite-scroll'

import mavonEditor from 'mavon-editor' // 解析 markdown 文件
import 'mavon-editor/dist/css/index.css'

Vue.use(infiniteScroll)

Vue.prototype.$API = API
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
// Vue.use(Llsweb)

Vue.prototype.GLOBAL = globalVariable
Vue.prototype.choosedCompPortal = {}
Vue.use(I18nPdfViewer);
Vue.use(LinkUI);
// use
Vue.use(mavonEditor)
//请求拦截器
// Vue.http.interceptors.push((request, next) => {
//     var api = "autoDemo";
//     request.url = (api + request.url);
//  	  console.log("接口请求："+request.url+"，参数串："+JSON.stringify(request.params));
//  	  // continue to next interceptor
// 　　next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
//         if(response.status == "404") {
//             var firUrl = request.url.replace(api,"");
//             response.msg = "<span style='text-align:left'>接口请求失败，原因可能如下，请检查</span>：</br><span style='font-size:13px;'>1、接口地址不正确；</span></br><span style='font-size:13px;'>2、当前服务不提供该接口（"+firUrl+"）</span>";
//         } else {
//           // if(response.body.httpCode == undefined) {
//           //   if(response.body.indexOf("<!DOCTYPE html>") != -1) {
//           //     response.body = [];
//           //     response.body.msg = "登录超时，请重新登录";
//           //   } else {
//           //     response.body = eval('(' + response.body + ')');
//           //   }
//           // }
//         }
//     		// response.msg = "网络请求失败，请重新登录后再尝试";
//      		console.log("接口响应："+response.url+"，状态码："+response.status+"，结果体："+JSON.stringify(response.body));
// 　　　　return response;
//     });
// });

// router.beforeEach((to,from,next)=>{
//     // console.log(router,'父组件路由器');
//     // console.log(to,'===内部路由器===');
//     if(to.path.includes('/child-iDDPortal') && to.path.includes('/childUserPt')){
//         debugger
//         console.log(to,'========去的路由=========');
//         next()
//     }else {
//         next()
//     }
// })

const getActiveRule = hash => location => location.hash.startsWith(hash)
store.state.projectFinishFlag = false
httpsAxios().finally(() => {
  // debugger
  window.vm.$store.state.projectFinishFlag = true
  // console.log(window.vm,'================')
})
window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
// console.log(window.vm,'================')
//配置子应用
const apps = [
  // {
  //     name:'iDDPortal',//应用名字
  //     entry:process.env.NODE_ENV === 'production' ? '/iDDPortal/' :'//localhost:7878',//默认会加载这个HTML 动态加载资源 （必须支持跨域）
  //     // fetch
  //     container:'#iDDPortal', //容器名
  //     activeRule:getActiveRule('#/child-iDDPortal/')  //激活路径
  // },
  // {
  //     name:'abdSpy',//应用名字
  //     entry:'//localhost:9998',//默认会加载这个HTML 动态加载资源 （必须支持跨域）
  //     // fetch
  //     container:'#abdSpy', //容器名
  //     activeRule:'/abdSpy/' //激活路径
  // }
]

// registerMicroApps(apps);
// start()
// prefetchApps([
//     { name: 'iDDPortal', entry: process.env.NODE_ENV === 'production' ? '/iDDPortal/' :'//localhost:7878' },
//     { name: 'cbfUserPortal', entry: process.env.NODE_ENV === 'production' ? '/cbfUserPortal/' :'//localhost:9990' },
// ]);
const state = {
  eventName: '', //事件名称
  shop: '', // 店铺
  curPagePath: '',
  langlocale: localStorage.getItem('locale') || 'en',
  childLocale: localStorage.getItem('childLocale') || 'zh',
  iddLocal: localStorage.getItem('iddLocal') || 'zh', //控制idd子应用的语言
  efinanceLocal: localStorage.getItem('efinanceLocal') || 'zh', //控制efinace子应用的语言
  tradeRole: localStorage.getItem('tradeRole') || 'SUPPLIER',
  currentPageBtnPermission: [], // 当前页面按钮权限配置digipo新增
  enterprise: {},
  cartNum: 0,
  exportDrawbackMenuList:{} //出口退税产品菜单
}
const { onGlobalStateChange, setGlobalState } = initGlobalState(state)
onGlobalStateChange((state, prev) => {
  // state: 变更后的状态; prev 变更前的状态
  // console.log('main-app onGlobalStateChange', state, prev)
  if (prev.curPagePath != state.curPagePath) {
    console.log('路由变化了')
    window.vm.$emit('childRouteChange', state.curPagePath)
  }
  if (prev.langlocale != state.langlocale) {
    localStorage.setItem('locale', state.langlocale)
    window.vm.$i18n.locale = state.langlocale
    window.vm.$emit('langChange')
  }
  if (prev.tradeRole != state.tradeRole) {
    localStorage.setItem('tradeRole', state.tradeRole)
    sessionStorage.setItem('tradeRole', state.tradeRole)
    window.vm.$emit('tradeRoleChange', state.tradeRole)
  }
  if (prev.childLocale != state.childLocale) {
    localStorage.setItem('childLocale', state.childLocale)
    window.vm.$emit('childLangChange')
  }
  if (state.eventName == 'changeEnterprise') {
    window.vm.$emit('changeEnterprise', state.enterprise)
  }
  if (state.eventName == 'addCart') {
    window.vm.$emit('addCart', state.cartNum)
  }
  if(state.eventName=='digipo_showDownloadMgm'){
    window.vm.$emit('digipo_showDownloadMgm')
  }
})
Vue.prototype.$setGlobalState = setGlobalState
// 初始化 state
// const actions = initGlobalState(state);
// actions.onGlobalStateChange((state, prev) => {
//     // state: 变更后的状态; prev 变更前的状态
//     console.log(state, prev);
//   });
// actions.setGlobalState(state);
// actions.offGlobalStateChange();
